if (!customElements.get('ly-faq-list-item')) {
    customElements.define('ly-faq-list-item', class extends HTMLElement {
        connectedCallback() {
            this.checkbox = this.querySelector('input')

            this.handleChange()
            this.checkbox.addEventListener('change', this.handleChange)
        }

        disconnectedCallback() {
            this.checkbox.removeEventListener('change', this.handleChange)
        }

        handleChange = () => {
            this.classList.toggle('is-open', this.checkbox.checked)
        }
    })
}